const TEST_ATTR = "id" as const;

export const generateTestId = (
  ...args: (string | number | boolean | null | undefined)[]
) => {
  const lastArg = args.at(-1);
  const ignorePrefix = typeof lastArg === "boolean" ? lastArg : false;
  const parts = typeof lastArg === "boolean" ? args.slice(0, -1) : args;

  return {
    [TEST_ATTR]: [...(!ignorePrefix ? ["cy"] : []), ...parts]
      .filter((p): p is string | number | boolean => p != null)
      .map((p) => String(p).trim().toLowerCase().replace(/\s+/g, "-"))
      .join("-"),
  };
};
